<template>
    <div class="last-played-games">
        <i class="fas fa-chevron-left" v-if="pageIndex > 1" @click="previousGames"></i>
        <i class="fas fa-chevron-right" v-if="pageIndex < 5 && !disableNext" @click="nextGames"></i>
        
        <transition name="fadeMenuOverlay" mode="out-in">
            <div class="games" :key="pageIndex">
                
                <div :class="'game ' + (!game2Infos ? 'soloGame' : '')">
                    <router-link :to="'/' + gameUrl1" :title="gameName1">
                        <div class="img"><div class="background" :style="{'background-image' : 'url(\'static/miniatures/'+gameImage1+'\')'}"></div></div>
                        <div class="right">
                            <h3>{{ truncateTitle(gameName1) }}</h3>
                            <p>a été joué il y a {{ gameDate1 }}</p>
                            <span>{{ gameCategory1 }}</span>
                        </div>
                    </router-link>
                </div>
                
                <div class="game" v-if="game2Infos">
                    <router-link :to="'/' + gameUrl2" :title="gameName2">
                        <div class="img"><div class="background" :style="{'background-image' : 'url(\'static/miniatures/'+gameImage2+'\')'}"></div></div>
                        <div class="right">
                            <h3>{{ truncateTitle(gameName2) }}</h3>
                            <p>a été joué il y a {{ gameDate2 }}</p>
                            <span>{{ gameCategory2 }}</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'GamesFeed',
        data() {
            return {
                lastPlayedGames: [],
                pageIndex: 1,

                gameUrl1: '',
                gameUrl2: '',
                gameImage1: '',
                gameImage2: '',
                gameDate1: '',
                gameDate2: '',
                gameCategory1: '',
                gameCategory2: '',
                gameName1: '',
                gameName2: '',

                disableNext: false,
                game2Infos: false,

                game1Index: 0,
                game2Index: 1
            }
        },
        mounted() {
            this.getLastPlayedGames();
        },
        methods: {
            getLastPlayedGames() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({ post: "1" }));
                
                axios
                .post(this.$store.state.apiUrl+"?request=getLastPlayedGames", formData)
                .then((response) => {
                    if(response.data.length > 0) {
                        this.lastPlayedGames = response.data;

                        this.editGame1Infos();

                        if(this.lastPlayedGames[this.game2Index] !== undefined) {
                            this.game2Infos = true;
                            this.editGame2Infos();
                        }
                        else {
                            this.game2Infos = false;
                        }
                    }
                });
            },
            timeAgo(time) {
                var seconds = Math.floor((new Date() - time.getTime()) / 1000);
                var intervalType;

                var interval = Math.floor(seconds / 31536000);
                if (interval >= 1) {
                    intervalType = 'an';
                } else {
                    interval = Math.floor(seconds / 2592000);
                    if (interval >= 1) {
                        intervalType = 'mois';
                    } else {
                        interval = Math.floor(seconds / 86400);
                        if (interval >= 1) {
                            intervalType = 'jour';
                        } else {
                            interval = Math.floor(seconds / 3600);
                            if (interval >= 1) {
                                intervalType = "heure";
                            } else {
                                interval = Math.floor(seconds / 60);
                                if (interval >= 1) {
                                    intervalType = "minute";
                                } else {
                                    interval = seconds;
                                    intervalType = "seconde";
                                }
                            }
                        }
                    }
                }

                if (interval > 1 || interval === 0) {
                    if(intervalType != 'mois') {
                        intervalType += 's';
                    }
                }

                return interval + ' ' + intervalType;
            },
            previousGames() {
                this.pageIndex--;
                this.game1Index = this.game1Index - 2;

                if(this.game2Infos) {
                    this.game2Index = this.game2Index - 2;
                }
                
                this.game2Infos = true;

                this.editGame1Infos();
                this.editGame2Infos();
            },
            nextGames() {
                this.pageIndex++;
                this.game1Index = this.game1Index + 2;

                if(this.lastPlayedGames[this.game2Index+2] !== undefined) {
                    this.game2Infos = true;
                    this.game2Index = this.game2Index + 2;
                    this.editGame2Infos();
                }
                else {
                    this.game2Infos = false;
                }

                this.editGame1Infos();
            },
            editGame1Infos() {
                this.gameUrl1 = this.lastPlayedGames[this.game1Index].title_url;
                this.gameImage1 = this.lastPlayedGames[this.game1Index].image_url;
                this.gameDate1 = this.timeAgo(new Date(this.lastPlayedGames[this.game1Index].last_visit.replace(/-/g, "/")));
                this.gameCategory1 = this.lastPlayedGames[this.game1Index].libelle_categorie;
                this.gameName1 = this.lastPlayedGames[this.game1Index].title;

                this.checkNext();
            },
            editGame2Infos() {
                this.gameUrl2 = this.lastPlayedGames[this.game2Index].title_url;
                this.gameImage2 = this.lastPlayedGames[this.game2Index].image_url;
                this.gameDate2 = this.timeAgo(new Date(this.lastPlayedGames[this.game2Index].last_visit.replace(/-/g, "/")));
                this.gameCategory2 = this.lastPlayedGames[this.game2Index].libelle_categorie;
                this.gameName2 = this.lastPlayedGames[this.game2Index].title;
            },
            checkNext() {
                if(this.lastPlayedGames[this.game1Index+2] === undefined) {
                    this.disableNext = true;
                }
                else {
                    this.disableNext = false;
                }
            },
            truncateTitle(value) {
                return value && value.length > 28 ? value.slice(0,28).split(' ').slice(0, -1).join(' ').concat('...') : value;
            }
        }
    }
</script>

<style scoped src="@/assets/gamesFeed.css">
</style>